export const PLUGIN_ID = 'iconic-wds';
export const VALIDATION_ERROR_ID_DATE = 'iconic-wds-date';
export const VALIDATION_ERROR_ID_TIME = 'iconic-wds-time';

/**
 * Subscription store name.
 */
export const SUBSCRIPTIONS_STORE_NAME = 'iconic-wds/subscriptions';

/**
 * External constants.
 */
export const WC_CART_STORE_NAME = 'wc/store/cart';
